////////LIBRARY/////////
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { isUndefined } from 'lodash'

/////////STYLED/////////
const ButtonAction = styled.button`
	display: ${(props) => (props.displayNone ? 'none' : 'flex')};
	justify-content: center;
	align-items: center;
	padding: ${(props) =>
		props.hasImg && !props.noHash && !props.position
			? `0px 40px 0px 15px`
			: props.padding
			? `0 ${props.padding}px`
			: props.position
			? `0px 58px 0px 15px`
			: '0 15px'};
	background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.colors.primary)};
	border-radius: ${(props) => (props.radius ? props.radius : '4px ')};
	font-weight: ${(props) => (props.weight === 'bold' ? 'bold' : 900 || props.weight === 'normal' ? 'normal' : 400)};
	font-size: ${(props) => props.theme.font.fs};
	color: ${(props) => (props.color ? props.color : props.theme.colors.white)};
	cursor: pointer;
	height: ${(props) => (props.height ? `${props.height}px` : 'auto')};
	width: ${(props) => (props.width ? `${props.width}px` : 'auto')};
	margin-right: ${(props) => (props.margin ? '16px' : '0')};
	text-align: center;
	text-transform: ${(props) => (props.caps ? 'uppercase' : 'inherit')};
	border: ${(props) => (props.borderColor ? `1px solid ${props.borderColor}` : 'none')};
	font-family: 'Lato', sans-serif;
	flex-direction: ${(props) => (props.direction ? props.direction : 'none')};
	:hover {
		background-color: ${(props) =>
			props.disabled
				? ''
				: props.bgcolor === props.theme.colors.validation
				? props.theme.colors.hoverValidation
				: props.bgcolor === props.theme.colors.error
				? props.theme.colors.hoverError
				: props.bgcolor === props.theme.colors.warning
				? props.theme.colors.warning
				: props.bgcolor === props.theme.colors.white
				? props.theme.colors.white
				: props.theme.colors.hoverPrimary};
	}
	transition: background-color 0.1s;
	margin-left: ${(props) => (props.mgLeft ? props.mgLeft : '0')};
`
const ButtonImage = styled.img`
	margin-right: ${(props) => (props.imgMgin ? props.imgMgin : '24px')};
	height: ${(props) => (props.iconHeight ? props.iconHeight : '16px')};
	width: ${(props) => (props.iconWidth ? props.iconWidth : '24px')};
	margin-left: ${(props) => (props.imgLeftMgin ? props.imgLeftMgin : null)};
	display: ${(props) => (props.displayNone ? 'none' : null)};
`
const ButtonActionLink = styled(Link)`
	text-decoration: none;
	display: ${(props) => (props.displayNone ? 'none' : 'flex')};
	justify-content: center;
	align-items: center;
	padding: ${(props) => (props.hasImg ? `0px 40px 0px 15px` : props.padding ? `0 ${props.padding}px` : '0 15px')};
	height: ${(props) => (props.height ? `${props.height}px` : `auto`)};
	background-color: ${(props) => (props.bgcolor ? props.bgcolor : props.theme.colors.primary)};
	border-radius: 4px;
	font-weight: ${(props) => (props.weight === 'bold' ? 'bold' : 900)};
	font-size: ${(props) => props.theme.font.fs};
	color: ${(props) => (props.color ? props.color : props.theme.colors.white)};
	cursor: pointer;
	margin-right: ${(props) => (props.margin ? '16px' : '0')};
	text-align: center;
	text-transform: ${(props) => (props.caps ? 'uppercase' : 'inherit')};
	border: ${(props) => (props.borderColor ? `1px solid ${props.borderColor}` : 'none')};
	margin-left: ${(props) => (props.mgLeft ? props.mgLeft : '0')};
	:hover {
		background-color: ${(props) =>
			props.disabled
				? ''
				: props.bgcolor === props.theme.colors.validation
				? props.theme.colors.hoverValidation
				: props.bgcolor === props.theme.colors.error
				? props.theme.colors.hoverError
				: props.bgcolor === props.theme.colors.warning
				? props.theme.colors.warning
				: props.bgcolor === props.theme.colors.white
				? props.theme.colors.white
				: props.theme.colors.hoverPrimary};
	}
`
const GoBackIcone = styled.div`
	width: 0;
	height: 0;
	border-top: 6px solid transparent;
	border-bottom: 6px solid transparent;
	border-right: 8px solid ${(props) => props.theme.colors.white};
	margin-right: 6px;
`
const ButtonActionDisabled = styled(ButtonAction)`
	background-color: ${(props) => props.theme.colors.grey};
	opacity: 0.5;
	cursor: not-allowed;
	:hover {
		cursor: not-allowed;
	}
`
/////////STYLED/////////

/**
 *
 * @param {string} link url to redirect
 * @param padding
 * @param {src} img src to img
 * @param {string} text text to display
 * @param {function} actionHandler onClick action
 * @param {string} color
 * @param {string} bgColor
 * @param {string} margin
 * @param {string} weight
 * @param {boolean} goBack
 * @param {boolean} disabled
 * @param {boolean} caps
 * @param {string} target if blank link
 * @param height
 * @param borderColor
 * @param width
 * @param {string} direction
 * @param {string} noHash
 * @param {string} radius
 * @param {string} imgMgin
 * @param {int} position
 * @param {string} imgLeftMgin
 * @param {int} id
 */
const Button = ({
	link,
	padding,
	img,
	text,
	actionHandler,
	color,
	bgColor,
	margin,
	weight,
	goBack,
	disabled,
	caps,
	target,
	bType = '',
	height,
	borderColor,
	as,
	iconHeight,
	iconWidth,
	direction,
	width,
	noHash,
	radius,
	imgMgin,
	id,
	mgLeft,
	position,
	imgLeftMgin,
	displayNone,
}) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return link ? (
		disabled ? (
			<ButtonActionDisabled
				color={color}
				bgcolor={bgColor}
				margin={margin}
				weight={weight}
				goback={goBack}
				padding={padding}
				height={height}
				caps={caps && caps.toString()}
				hasImg={!isUndefined(img)}
				borderColor={borderColor}
				disabled={disabled}
				as={as}
				id={id}
				mgLeft={mgLeft}
				noHash={noHash}
			>
				{img && <ButtonImage iconHeight={iconHeight} iconWidth={iconWidth} src={img} imgMgin={imgMgin} displayNone={displayNone} />}
				{goBack && <GoBackIcone />}
				{text}
			</ButtonActionDisabled>
		) : (
			<ButtonActionLink
				to={link}
				onClick={actionHandler}
				color={color}
				bgcolor={bgColor}
				margin={margin}
				weight={weight}
				goback={goBack}
				padding={padding}
				target={target}
				height={height}
				caps={caps && caps.toString()}
				hasImg={!isUndefined(img)}
				borderColor={borderColor}
				as={as}
				id={id}
				mgLeft={mgLeft}
			>
				{img && <ButtonImage iconHeight={iconHeight} iconWidth={iconWidth} src={img} imgMgin={imgMgin} displayNone={displayNone} />}
				{goBack && <GoBackIcone />}
				{text}
			</ButtonActionLink>
		)
	) : disabled ? (
		<ButtonActionDisabled
			color={color}
			bgcolor={bgColor}
			margin={margin}
			weight={weight}
			goback={goBack}
			padding={padding}
			height={height}
			caps={caps && caps.toString()}
			hasImg={!isUndefined(img)}
			borderColor={borderColor}
			disabled={disabled}
			as={as}
			id={id}
			mgLeft={mgLeft}
			noHash={noHash}
		>
			{img && (
				<ButtonImage
					iconHeight={iconHeight}
					iconWidth={iconWidth}
					src={img}
					imgMgin={imgMgin}
					imgLeftMgin={imgLeftMgin}
					displayNone={displayNone}
				/>
			)}
			{goBack && <GoBackIcone />}
			{text}
		</ButtonActionDisabled>
	) : position === 2 ? (
		<ButtonAction
			color={color}
			onClick={actionHandler}
			bgcolor={bgColor}
			margin={margin}
			weight={weight}
			goback={goBack}
			padding={padding}
			height={height}
			caps={caps && caps.toString()}
			hasImg={!isUndefined(img)}
			borderColor={borderColor}
			disabled={disabled}
			width={width}
			radius={radius}
			as={as}
			id={id}
			position={true}
			mgLeft={mgLeft}
			displayNone={displayNone}
		>
			{img && (
				<ButtonImage
					iconHeight={iconHeight}
					iconWidth={iconWidth}
					src={img}
					imgMgin={imgMgin}
					imgLeftMgin={imgLeftMgin}
					displayNone={displayNone}
				/>
			)}
			{goBack && <GoBackIcone />}
			{text}
		</ButtonAction>
	) : (
		<ButtonAction
			color={color}
			onClick={actionHandler}
			bgcolor={bgColor}
			margin={margin}
			weight={weight}
			goback={goBack}
			padding={padding}
			height={height}
			caps={caps && caps.toString()}
			hasImg={!isUndefined(img)}
			borderColor={borderColor}
			type={bType}
			as={as}
			direction={direction}
			width={width}
			noHash={noHash}
			radius={radius}
			id={id}
			mgLeft={mgLeft}
			displayNone={displayNone}
		>
			{img && <ButtonImage iconHeight={iconHeight} iconWidth={iconWidth} src={img} imgMgin={imgMgin} displayNone={displayNone} />}
			{goBack && <GoBackIcone />}
			{text}
		</ButtonAction>
	)
}

Button.propTypes = {
	link: PropTypes.string,
	img: PropTypes.string,
	text: PropTypes.string,
	actionHandler: PropTypes.func,
	color: PropTypes.string,
	bgColor: PropTypes.string,
	margin: PropTypes.string,
	weight: PropTypes.string,
	goBack: PropTypes.bool,
	disabled: PropTypes.bool,
}

export default Button
